import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DVAccountType } from 'app/enum/DVAccountType';
import { CategoryService } from 'app/services/models/category.service';
import { CompanyService } from 'app/services/models/company.service';
import { CountryService } from 'app/services/models/country.service';
import { CurrencyService } from 'app/services/models/currency.service';
import { ProvinceService } from 'app/services/models/province.service';
import { UnitTypeService } from 'app/services/models/unit-type.service';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-create-company',
  templateUrl: './create-company.component.html',
  styleUrls: ['./create-company.component.scss']
})
export class CreateCompanyComponent implements OnInit {
  @BlockUI('section-blocks') blockUI: NgBlockUI;
  companyForm: FormGroup; // Form için tanımlama

  categories: any[] = [];
  currencies: any[] = [];
  unitTypes: any[] = [];
  countries: any[] = [];
  provinces: any[] = [];
  districts: any[] = [];
  selectedAccountType: number = 2;

  constructor(
    public activeModal: NgbActiveModal,
    private fb: FormBuilder,
    private currencyService: CurrencyService,
    private categoryService: CategoryService,
    private companyService: CompanyService,
    private toastrService: ToastrService,
    private countryService: CountryService,
    private provinceService: ProvinceService) {

    this.companyForm = this.fb.group({
      title: ['', Validators.required],
      currencyId: [1, Validators.required],
      categoryId: [null],
      discountRate: [0],
      futureDay: [null],
      districtId: [null],
      provinceId: [null, Validators.required],
      DVAccountType: [2, Validators.required],
    });
  }

  async ngOnInit() {
    await this.getAllCategories()
    await this.getAllCurrencies();
    await this.getAllCountry();
  }

  async getAllCurrencies() {
    const currency = await this.currencyService.getAllPageCurrency(0, 100, '');
    this.currencies = currency.currenies;
    console.log(this.currencies);
  }


  async getAllCategories() {
    const category = await this.categoryService.getAllCategory(0, 100, '', 2);
    this.categories = category.categories;
    console.log(this.categories);
  }

  closeModal() {
    this.activeModal.close(false);
  }

  async onSubmit() {
    this.blockUI.start("Firma ekleniyor...");
    if (this.companyForm.valid) {
      console.log(this.companyForm.value);
      const response = await this.companyService.createCompany({
        companyName: this.companyForm.value.title,
        currencyId: this.companyForm.value.currencyId,
        categoryId: this.companyForm.value.categoryId,
        discountRate: this.companyForm.value.discountRate,
        futuresDay: 15,
        phoneNumber: null,
        DVAccountType:this.companyForm.value.DVAccountType,
        districtId:this.companyForm.value.districtId ?  Number(this.companyForm.value.districtId): null,
        provinceId:Number(this.companyForm.value.provinceId)
      });
      if (response.status == true) {
        this.blockUI.stop();
        this.toastrService.success(response.message);
        this.companyService.sendEvent(true);
        this.closeModal();
      } else {
        this.blockUI.stop();
        this.toastrService.error(response.message);
      }
    }
  }

  async onCountryChange(event: any) {
    console.log(event.target.value);
    const countryId = event.target.value;
    await this.getAllProvince(countryId);
  }

  async getAllProvince(id) {
    const data = await this.provinceService.getAllProvince(id);
    console.log(data);
    this.provinces = data;
  }

  async getAllCountry() {
    const data = await this.countryService.getAllCountries();
    console.log(data);
    this.countries = data;
  }

  onProvinceChange(event: any) {
    const selectedProvinceId = event.target.value;

    // Seçilen ilin ID'sine göre ilçeleri filtrele
    const selectedProvince = this.provinces.find(p => p.id == selectedProvinceId);
    // console.log(selectedProvince);
    // const turkak = this.turkakCustomerData.Cities?.find(p => p.Name === selectedProvince.name);
    // console.log(turkak);
    // this.selectedTurkakCity = turkak;
    // Eğer il bulunduysa ilçelerini ata, yoksa boş bir liste ata
    this.districts = selectedProvince ? selectedProvince.districts : [];
  }

  onAccountTypeChange(event: any) {
    const selectedValue = this.companyForm.controls['DVAccountType'].value;
    this.selectedAccountType = selectedValue;
    console.log('Seçilen Hesap Türü:', this.selectedAccountType);
  }

  dvAccountTypes = Object.entries(DVAccountType)
    .filter(([key, value]) => !isNaN(Number(value))) // Sadece sayısal değerleri al
    .map(([key, value]) => ({ key, value })); // Nesne listesi haline getir
}
